import React, { useState, useEffect } from "react";
import {
  CommonHeader,
  EmptyListPage,
  ErrorSuccessModal,
  Loader
} from "../../../components/commons";
import { connect } from "react-redux";
import { RootState } from "../../../redux/rootReducers";
import { GetFileFolderCountPayloadType } from "../../../commonTypes/listing";
import { formatDate, handleDate } from "../../../utils/commonFunctions";
import { resetSession } from "../../../redux/auth";
import { FILE_FOLDER_HEADERS } from "../../../constant/tableHeadersConstants/fileFolderHeaderconst";
import FileAndFolderCountHeader from "../../../components/AdminReports/FileAndFolder/FileFolderCountHeader";
import FileFolderCountTable from "../../../components/AdminReports/FileAndFolder/FileFolderCountTable";
import { FileFolderImage } from "../../../assets/images";
import { getFileAndFolderAction, resetFileFolderCountData, resetListingError, resetListingSuccess } from "../../../redux/listing";
import { FileFolderCountType } from "../../../redux/listing/listingTypes";

type AppProps = {
  history?: any;
  token: string | null;
  fetching: boolean;
  error: string | null;
  success: number | null;
  statusCode: number | null;
  dataCount:[] | FileFolderCountType[]
  dispatchGetFileFolderDataAction: (data: GetFileFolderCountPayloadType) => void;
  dispatchResetSession: () => void;
  dispatchResetListingErrorAction: () => void;
  dispatchResetListingSuccessAction: () => void;
  dispatchResetFileFolderCount: () => void;
};


const FileAndFolder = ({
  history,
  token,
  fetching,
  success,
  error,
  statusCode,
  dispatchGetFileFolderDataAction,
  dispatchResetListingErrorAction,
  dispatchResetListingSuccessAction,
  dispatchResetSession,
  dataCount,
  dispatchResetFileFolderCount
}: AppProps) => {
  const company_name = history?.location?.state?.company_name;

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [displayStartDate, setDisplayStartDate] = useState("");
  const [displayEndDate, setDisplayEndDate] = useState("");

  useEffect(() => {
    dispatchResetListingErrorAction();
    dispatchResetListingSuccessAction();
    dispatchResetFileFolderCount();
  }, []);

  useEffect(() => {
    if (displayEndDate != endDate || startDate != displayStartDate) {
      setDisplayStartDate(formatDate(startDate));
      setDisplayEndDate(formatDate(endDate));
    }
  }, [dataCount]);

  const handleStartDateChange = (date: any) => {
    const value = handleDate(date);
    setStartDate(value);
  };

  const handleEndDateChange = (date: any) => {
    const value = handleDate(date);
    setEndDate(value);
  };

  const handleSubmitData = () => {  
    let finalData: GetFileFolderCountPayloadType = {
      token,
      start_date: formatDate(startDate),
      end_date: formatDate(endDate),
    };

    dispatchGetFileFolderDataAction(finalData);
    
  };

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (!!error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetListingErrorAction();
            }}
          />
        );
      }
    }

    return false;
  };

  return (
    <>
      <div className="row">
        <div className="col-md-6">
          <CommonHeader
            title="File And Folder Count"
          />
        </div>
      </div>
      <div className="col-md-12 mt-4">
        <div className="new-table-card">
            <FileAndFolderCountHeader
              startDate={startDate}
              endDate={endDate}
              handleStartDateChange={handleStartDateChange}
              handleEndDateChange={handleEndDateChange}
              handleSubmitData={handleSubmitData}
            />
            <hr className="mt-4 mb-4" />
            {dataCount && dataCount?.length === 0 && !fetching ? (
              <EmptyListPage
                title="No File And Folder Found!"
                text="Choose start date and end date to get File and Folder Count Details."
                image={FileFolderImage}
                imageWidth="30%"
              />
            ) : (
              <>
                <h5 className="text-center">File And Folder Count</h5>
                <h3 className="text-center">{company_name}</h3>
                <div className="d-flex justify-content-center mt-3">
                  <h6 className="text-center mr-4">
                    Start Date:{" "}
                    <span className="font-weight-bolder">
                      {displayStartDate.slice(0,10)}
                    </span>
                  </h6>
                  <h6 className="text-center">
                    End Date:{" "}
                    <span className="font-weight-bolder">{displayEndDate}</span>
                  </h6>
                </div>
                <FileFolderCountTable
                  fetching={fetching}                
                  data={dataCount}
                  tableHeaders={FILE_FOLDER_HEADERS}
                
                />
              </>
            )}
        </div>
      </div>
      {fetching && <Loader />}
      {handleErrorModal()}
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  fetching: state.listing.fetching,
  error: state.listing.error,
  statusCode: state.listing.statusCode,
  success: state.listing.success,
  dataCount:state.listing.fileFolderCount
});


const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetListingErrorAction: () => dispatch(resetListingError()),
  dispatchResetListingSuccessAction: () => dispatch(resetListingSuccess()),
  dispatchGetFileFolderDataAction: (data: GetFileFolderCountPayloadType) =>
    dispatch(getFileAndFolderAction(data)),
    
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetFileFolderCount: () => dispatch(resetFileFolderCountData()),
});

export default connect(mapStateToProps, mapDispatchToProps)(FileAndFolder);
